export default "__VITE_ASSET__BopRNfqD__"